import { I18n, getLocale } from "@devforce/trailhead-client-locale";

var data$9 = {
  durationMinute: "%{duration} Minute",
  durationMinutes: "%{duration} Minuten",
  durationHour: "%{duration} Stunde",
  durationHours: "%{duration} Stunden",
  todayTimestamp: "Heute, %{time}",
  yesterdayTimestamp: "Gestern, %{time}",
  lastActivity: "Zuletzt aktiv am %{date}",
};
data$9.durationMinute;
data$9.durationMinutes;
data$9.durationHour;
data$9.durationHours;
data$9.todayTimestamp;
data$9.yesterdayTimestamp;
data$9.lastActivity;

var data$8 = {
  durationMinute: "%{duration} min",
  durationMinutes: "%{duration} mins",
  durationHour: "%{duration} hr",
  durationHours: "%{duration} hrs",
  todayTimestamp: "Today, %{time}",
  yesterdayTimestamp: "Yesterday, %{time}",
  lastActivity: "Last active on %{date}",
};
data$8.durationMinute;
data$8.durationMinutes;
data$8.durationHour;
data$8.durationHours;
data$8.todayTimestamp;
data$8.yesterdayTimestamp;
data$8.lastActivity;

var data$7 = {
  durationMinute: "%{duration} minuto",
  durationMinutes: "%{duration} minutos",
  durationHour: "%{duration} hora",
  durationHours: "%{duration} horas",
  todayTimestamp: "Hoy, %{time}",
  yesterdayTimestamp: "Ayer, %{time}",
  lastActivity: "Última vez activo el %{date}",
};
data$7.durationMinute;
data$7.durationMinutes;
data$7.durationHour;
data$7.durationHours;
data$7.todayTimestamp;
data$7.yesterdayTimestamp;
data$7.lastActivity;

var data$6 = {
  durationMinute: "%{duration} minuto",
  durationMinutes: "%{duration} minutos",
  durationHour: "%{duration} hora",
  durationHours: "%{duration} horas",
  todayTimestamp: "Hoy, %{time}",
  yesterdayTimestamp: "Ayer, %{time}",
  lastActivity: "Última actividad el %{date}",
};
data$6.durationMinute;
data$6.durationMinutes;
data$6.durationHour;
data$6.durationHours;
data$6.todayTimestamp;
data$6.yesterdayTimestamp;
data$6.lastActivity;

var data$5 = {
  durationMinute: "%{duration} min",
  durationMinutes: "%{duration} min",
  durationHour: "%{duration} h",
  durationHours: "%{duration} h",
  todayTimestamp: "Aujourd’hui, à %{time}",
  yesterdayTimestamp: "Hier, à %{time}",
  lastActivity: "Dernière activité le %{date}",
};
data$5.durationMinute;
data$5.durationMinutes;
data$5.durationHour;
data$5.durationHours;
data$5.todayTimestamp;
data$5.yesterdayTimestamp;
data$5.lastActivity;

var data$4 = {
  durationMinute: "%{duration} minunto",
  durationMinutes: "%{duration} minuti",
  durationHour: "%{duration} ora",
  durationHours: "%{duration} ore",
  todayTimestamp: "Oggi alle ore %{time}",
  yesterdayTimestamp: "Ieri alle ore %{time}",
  lastActivity: "Data dell'ultima attività: %{date}",
};
data$4.durationMinute;
data$4.durationMinutes;
data$4.durationHour;
data$4.durationHours;
data$4.todayTimestamp;
data$4.yesterdayTimestamp;
data$4.lastActivity;

var data$3 = {
  durationMinute: "%{duration} 分",
  durationMinutes: "%{duration} 分",
  durationHour: "%{duration} 時間",
  durationHours: "%{duration} 時間",
  todayTimestamp: "今日、%{time}",
  yesterdayTimestamp: "昨日、%{time}",
  lastActivity: "最終活動日: %{date}",
};
data$3.durationMinute;
data$3.durationMinutes;
data$3.durationHour;
data$3.durationHours;
data$3.todayTimestamp;
data$3.yesterdayTimestamp;
data$3.lastActivity;

var data$2 = {
  durationMinute: "%{duration}분",
  durationMinutes: "%{duration} 분",
  durationHour: "%{duration}시간",
  durationHours: "%{duration} 시간",
  todayTimestamp: "오늘, %{time}",
  yesterdayTimestamp: "어제, %{time}",
  lastActivity: "마지막 활동일: %{date}",
};
data$2.durationMinute;
data$2.durationMinutes;
data$2.durationHour;
data$2.durationHours;
data$2.todayTimestamp;
data$2.yesterdayTimestamp;
data$2.lastActivity;

var data$1 = {
  durationMinute: "%{duration} min",
  durationMinutes: "%{duration} mins",
  durationHour: "%{duration} h",
  durationHours: "%{duration} h",
  todayTimestamp: "Hoje, %{time}",
  yesterdayTimestamp: "Ontem, %{time}",
  lastActivity: "Ativo pela última vez em %{date}",
};
data$1.durationMinute;
data$1.durationMinutes;
data$1.durationHour;
data$1.durationHours;
data$1.todayTimestamp;
data$1.yesterdayTimestamp;
data$1.lastActivity;

var data = {
  durationMinute: "%{duration} 分钟",
  durationMinutes: "%{duration} 分钟",
  durationHour: "%{duration} 小时",
  durationHours: "%{duration} 小时",
  todayTimestamp: "今天，%{time}",
  yesterdayTimestamp: "昨天，%{time}",
  lastActivity: "上次活跃时间 %{date}",
};
data.durationMinute;
data.durationMinutes;
data.durationHour;
data.durationHours;
data.todayTimestamp;
data.yesterdayTimestamp;
data.lastActivity;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

const i18n = new I18n({
  helpers: locales,
});
function isYesterday(date, today) {
  const differenceMS = today.getTime() - date.getTime();
  const differenceDays = differenceMS / (1000 * 3600 * 24);
  return differenceDays > 1 && differenceDays < 2;
}
function timestamp(createdAt) {
  const date = new Date(createdAt);
  const today = new Date();
  const isToday = date.toDateString() === today.toDateString();
  const isThisYear = date.getFullYear() === today.getFullYear();
  const yesterday = isYesterday(date, today);
  const timeFormatter = new Intl.DateTimeFormat(getLocale(), {
    month: isToday || yesterday ? undefined : "short",
    day: isToday || yesterday ? undefined : "numeric",
    year: isToday || yesterday || isThisYear ? undefined : "numeric",
    hour: "numeric",
    minute: "numeric",
  });
  const dateTime = timeFormatter.format(date);
  if (isToday) {
    return i18n.t("helpers", "todayTimestamp", {
      time: dateTime,
    });
  } else if (yesterday) {
    return i18n.t("helpers", "yesterdayTimestamp", {
      time: dateTime,
    });
  }
  return dateTime;
}
function lastActivity(isoString) {
  if (isoString) {
    const formatter = new Intl.DateTimeFormat(getLocale(), {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
    const date = new Date(isoString);
    const formatted = formatter.format(date);
    return i18n.t("helpers", "lastActivity", {
      date: formatted,
    });
  }
  return "";
}
function formatDuration(seconds) {
  // Calculate hours, minutes, and remaining seconds
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // Format the remaining seconds to always have two digits
  const formattedSeconds = remainingSeconds.toString().padStart(2, "0");

  // Determine the correct label for hours and minutes
  if (hours > 0) {
    const hourLabelKey = hours === 1 ? "durationHour" : "durationHours";
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return i18n.t("helpers", hourLabelKey, {
      duration: `${hours}:${formattedMinutes}:${formattedSeconds}`,
    });
  } else {
    const minuteLabelKey = minutes === 1 ? "durationMinute" : "durationMinutes";
    return i18n.t("helpers", minuteLabelKey, {
      duration: `${minutes}:${formattedSeconds}`,
    });
  }
}
function isOverdue(dueDate) {
  if (!dueDate) return false;

  // Get user's timezone
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Get current time in user's timezone
  const now = new Date().toLocaleString("en-US", {
    timeZone: userTimeZone,
  });
  const nowDate = new Date(now);
  nowDate.setHours(0, 0, 0, 0);

  // Parse the due date and convert to user's timezone
  const dateOnly = dueDate.split("T")[0];
  const [year, month, day] = dateOnly.split("-").map(Number);
  const dueDateObj = new Date(year, month - 1, day);
  const dueDateInTz = new Date(
    dueDateObj.toLocaleString("en-US", {
      timeZone: userTimeZone,
    })
  );

  // Set to midnight of the next day (end of due date)
  const dueAtMidnight = new Date(dueDateInTz);
  dueAtMidnight.setHours(0, 0, 0, 0);
  dueAtMidnight.setDate(dueAtMidnight.getDate() + 1);
  return nowDate >= dueAtMidnight;
}

/**
 * Formats a date string with consistent short format (e.g., "Jan 15, 2024")
 * @param dateString ISO date string, date-only string (YYYY-MM-DD), or various other date formats
 * @returns Formatted date string, or original string if parsing fails
 */
function formatShortDate(dateString) {
  if (!dateString) return "";
  let dateObj;
  if (dateString.includes("-") && dateString.match(/^\d{4}-\d{1,2}-\d{1,2}$/)) {
    const dateOnly = dateString.split("T")[0];
    const [year, month, day] = dateOnly.split("-").map(Number);

    // Confirm this is a valid date before creating Date object
    if (month < 1 || month > 12 || day < 1 || day > 31) {
      return dateString;
    }
    dateObj = new Date(year, month - 1, day);

    // Confirm the created date matches input
    if (
      dateObj.getFullYear() !== year ||
      dateObj.getMonth() !== month - 1 ||
      dateObj.getDate() !== day
    ) {
      return dateString;
    }
  } else {
    // Fall back to native Date parsing for other formats
    dateObj = new Date(dateString);
  }

  // Check if date is valid
  if (isNaN(dateObj.getTime())) {
    // If parsing fails, return the original string
    return dateString;
  }
  const formatter = new Intl.DateTimeFormat(getLocale(), {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return formatter.format(dateObj);
}

export {
  formatDuration as a,
  formatShortDate as f,
  isOverdue as i,
  lastActivity as l,
  timestamp as t,
};
